import type { ReactNode } from "react";
import { motion } from "framer-motion";
import { SectionHeading } from "./SectionHeading";

const services: {
  title: string;
  description: ReactNode;
}[] = [
  {
    title: "Promotional Film",
    description: "Authentic, impactful messaging that captures the essence of your brand and resonates with your audience. No-nonsense. Who you are. What sets you apart. Why customers NEED you."
  },
  {
    title: "Video Podcasts",
    description: (
      <>
        Premium video podcasts that are strategic and unique to your brand. Not just renting a studio, a camera and microphones. Content with business intent.{" "}
        <a
          href="https://www.youtube.com/@BlackSwanProductions"
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary underline underline-offset-4 hover:text-white transition-colors duration-300"
        >
          Our own podcast
        </a>{" "}
        shows we're experts.
      </>
    )
  },
  {
    title: "Event Filming",
    description: "We've filmed and photographed events in Wales, London, Manchester and Edinburgh. Typically a combination of a promo video, talking head interviews, filming presentations/conversations."
  },
  {
    title: "Video Strategies",
    description: "Strategic not reactive video production efforts. Instead of something happening in business or marketing causing you to produce a video, we plan ahead. Using video at the start of your plan."
  }
];

export function Services() {
  return (
    <section id="services" className="py-32 bg-zinc-950 relative">
      <div className="container mx-auto px-6">
        <SectionHeading className="mb-16">Our Services</SectionHeading>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-16">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="group border-t border-white/10 pt-8"
            >
              <div className="flex flex-col gap-4">
                <span className="text-primary font-mono text-sm opacity-50">0{index + 1}</span>
                <h3 className="font-display text-3xl font-bold group-hover:text-primary transition-colors duration-300">
                  {service.title}
                </h3>
                <p className="text-gray-400 text-lg leading-relaxed mt-2 max-w-md">
                  {service.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
